var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 2357 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11914",
    d: "M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 11.143A5.143 5.143 0 1 1 13.143 8 5.143 5.143 0 0 1 8 13.143z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11765"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3634",
    transform: "translate(5.571 4.714)",
    style: {
      fill: "#666"
    },
    d: "M0 0h.857v4.714H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11915",
    d: "M15.143 23.286a.643.643 0 1 1 .643-.643.643.643 0 0 1-.643.643z",
    transform: "translate(-9.143 -19.43)",
    style: {
      fill: "#666"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.26cf3b7862110177c2d9ef24cd53841b.svg";
export { ForwardRef as ReactComponent };